import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Admin from './Admin';
import InventoryPage from './InventoryPage';
import Sidebar from './Sidebar';
import ShipmentPage from './ShipmentPage';
import ProspectingPage from './ProspectingPage';
import CustomerHealthDashboard from './CustomerHealthDashboard';
import ContractingPage from './ContractingPage';
import ROICalculator from './ROICalculator';
import TrialPipelinePage from './TrialPipelinePage';
import PowerHourPage from './PowerHourPage';
import PowerHourTV from './PowerHourTV';
import PowerHourConfig from './PowerHourConfig';
import PowerHourGuide from './PowerHourGuide';
import PowerHourCoins from './PowerHourCoins';
import E2SummitTV from './E2SummitTV';
import DataCurationPage from './DataCurationPage';
import CustomerManagementPage from './CustomerManagementPage';
import './Layout.css';

const PageTitle = () => {
  const location = useLocation();
  const path = location.pathname.startsWith('/power-hour') ? '/power-hour' : location.pathname;

  const titles: { [key: string]: string } = {
    '/customers': 'Customers',
    '/admin': 'Admin',
    '/inventory': 'Inventory',
    '/shipments': 'Shipments',
    '/prospecting': 'Lead Finder',
    '/contracting': 'Contracting',
    '/roi': 'ROI Calculator',
    '/trials': 'Trial Pipeline',
    '/power-hour': 'Earn the Summit',
    '/data-curation': 'Data Curation',
    '/customer-management': 'Customer Management',
    '/e2-summit': 'E2 Summit',
  };

  return <h1>{titles[path] || titles['/customers']}</h1>;
};

const Layout: React.FC = () => {
  const location = useLocation();
  // Earn the Summit pages and the E2 Summit wall carry their own branded header — skip the app one
  const hideHeader = location.pathname.startsWith('/power-hour') || location.pathname === '/e2-summit';
  return (
    <div className="App">
      <div className="app-container">
        <Sidebar />
        <div className="main-content">
          {!hideHeader && (
            <header className="App-header">
              <PageTitle />
            </header>
          )}
          <main className="content-area">
            <Routes>
              {/* /customers is now the upgraded health dashboard (Phase 5).
                  The old DeviceManager-based admin views moved to /admin. */}
              <Route path="/customers" element={<CustomerHealthDashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/shipments" element={<ShipmentPage />} />
              <Route path="/prospecting" element={<ProspectingPage />} />
              <Route path="/contracting" element={<ContractingPage />} />
              <Route path="/roi" element={<ROICalculator />} />
              {/* /intel (Call Analytics) removed for now — Power Hour replaces it */}
              <Route path="/intel" element={<Navigate to="/power-hour" replace />} />
              <Route path="/trials" element={<TrialPipelinePage />} />
              <Route path="/data-curation" element={<DataCurationPage />} />
              <Route path="/customer-management" element={<CustomerManagementPage />} />
              <Route path="/e2-summit" element={<E2SummitTV />} />
              <Route path="/wearer-hands" element={<Navigate to="/data-curation" replace />} />
              <Route path="/power-hour" element={<PowerHourPage />} />
              <Route path="/power-hour/tv" element={<PowerHourTV />} />
              <Route path="/power-hour/config" element={<PowerHourConfig />} />
              <Route path="/power-hour/guide" element={<PowerHourGuide />} />
              <Route path="/power-hour/coins" element={<PowerHourCoins />} />
              {/* The E2 wall moved to Data Management; old TV bookmarks still land on it */}
              <Route path="/power-hour/e2" element={<Navigate to="/e2-summit" replace />} />
              <Route path="/power-hour/:code" element={<PowerHourPage />} />
              {/* Preserve old bookmarks */}
              <Route path="/health" element={<Navigate to="/customers" replace />} />
              <Route path="/stats" element={<Navigate to="/customers" replace />} />
              <Route path="/devices" element={<Navigate to="/customers" replace />} />
              <Route path="/" element={<Navigate to="/customers" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
